export const EMOTION_NAMES = [
  "Amazement", "Anger", "Cheekiness", "Disgust",
  "Fear", "Grief", "Joy", "OutOfBreath", "Pain", "Sadness"
]
